import React from 'react'

export interface ArrowRightCircleProps {
  size?: number
  color?: string
}

export const ArrowRightCircle: React.FC<ArrowRightCircleProps> = ({
  size = 24,
  color = '#fff',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 60 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_35188_68654)" fill={color}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 30.5c0 16.569 13.432 30 30 30 16.569 0 30-13.431 30-30 0-16.569-13.431-30-30-30-16.568 0-30 13.431-30 30zm6 0c0 13.255 10.745 24 24 24s24-10.745 24-24-10.745-24-24-24-24 10.745-24 24z"
        />
        <path
          d="M43.25 30.533a1.996 1.996 0 01-.618 1.442h0l-9.065 8.954a1.05 1.05 0 01-1.475 0l-1.416-1.398a1.05 1.05 0 010-1.494l5.522-5.455H17.8c-.58 0-1.05-.47-1.05-1.05v-1.999c0-.58.47-1.05 1.05-1.05h18.412l-5.54-5.522a1.05 1.05 0 01.003-1.49l1.416-1.399a1.05 1.05 0 011.477.003l9.067 9.017h-.001a2.007 2.007 0 01.616 1.441z"
          stroke={color}
          strokeWidth={1.5}
        />
      </g>
      <defs>
        <clipPath id="clip0_35188_68654">
          <path
            fill={color}
            transform="rotate(90 29.75 30.25)"
            d="M0 0H60V60H0z"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
